import * as React from 'react';
import {useEffect, useState} from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {Box, CircularProgress, Collapse} from '@mui/material';
import {KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import productService from '../../services/ProductService';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from '../../util/SnackbarProvider';
import IconButton from "@mui/material/IconButton";

const columns = [
    {id: 'productName', label: 'Termék', fun: (v, r, n) => <span style={{color: 'blue', textDecoration: "underline"}} onClick={() => n(`/dashboard/storage/products/${r.productId}`)}>{v}</span>},
    {id: 'totalQuantityToOrder', label: 'Össz. Rendelendő Mennyiség', align: 'center'},
];

const nestedColumns = [
    {id: 'substorage', label: 'Raktár', width: "500px", fun: (v, r, n) => r.shortageDueToReservations > 0 ? <span style={{color: 'blue', textDecoration: "underline", cursor: "pointer"}} onClick={() => n(`/dashboard/product-projects/${r.productProjectId}/iterations/${r.productProjectIterationId}`)}>{v}</span> : v},
    {id: 'currentAmount', label: 'Jelenlegi Mennyiség', align: 'center'},
    {id: 'minimumStockInStorage', label: 'Minimum készlet', align: 'center'},
    {id: 'shortageDueToReservations', label: 'Foglalás', align: 'center'},
    {id: 'totalQuantityToOrder', label: 'Rendelendő Mennyiség', align: 'center'},
    {id: '', label: '',width: "50px", align: 'center', fun: (c, r) => <span style={{fontSize: "20px", lineHeight: "1"}}>{r.totalQuantityToOrder > 0 ? '⚠️' : '✅'}</span>},
];

const LOCAL_STORAGE_ITEM_NAME = "product-rows-per-page"
const LOCAL_STORAGE_SEARCH_PARAMS = "product-search-params"

export default function ProductsToOrder() {

    useTitle([{name: 'Rendelendő Termékek'}])

    const [tableData, setTableData] = useState({
        page: 0,
        rowsPerPage: localStorage.getItem(LOCAL_STORAGE_ITEM_NAME) || 25,
        totalCount: 0
    })
    const [expanded, setExpanded] = useState(true);
    const [searchParams, setSearchParams] = useState(JSON.parse(localStorage.getItem(LOCAL_STORAGE_SEARCH_PARAMS)))
    const {sendAlertMessage} = useSnackbar()

    useEffect(() => {
        productService.findAllProductsToOrder(buildQueryParams())
            .then(response => setTableData((prev) => ({...prev, totalCount: response.totalElements, rows: response.content})))
            .catch((error) => {
                sendAlertMessage(error?.message || 'Termékek lekérése sikertelen!', 'error')
                setTableData((prev) => ({...prev, rows: []}))
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData.page, tableData.rowsPerPage, searchParams]);

    function buildQueryParams() {
        const filteredSearchParams = searchParams ? Object.fromEntries(Object.entries(searchParams).filter(([, value]) => value !== '')) : {};
        return {
            page: tableData.page,
            size: tableData.rowsPerPage,
            ...filteredSearchParams
        }
    }

    const onSearchParamsChange = (event) => {
        const {name, value} = event.target
        setSearchParams((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const clear = () => {
        if (searchParams != null) sendAlertMessage('Szűrők alaphelyzetbe állítva', 'info')
        setSearchParams(undefined)
    }

    useEffect(() => {
        if (searchParams) localStorage.setItem(LOCAL_STORAGE_SEARCH_PARAMS, JSON.stringify(searchParams));
        else localStorage.removeItem(LOCAL_STORAGE_SEARCH_PARAMS)
    }, [searchParams]);

    const navigate = useNavigate();

    return (
        <>
            {/*<Accordion style={{marginBottom: "10px"}} disableGutters expanded={expanded}*/}
            {/*           onChange={() => setExpanded(!expanded)}>*/}
            {/*    <AccordionSummary*/}
            {/*        expandIcon={<KeyboardArrowDown sx={{marginRight: "0px", height: "2em", width: "auto"}}/>} sx={{*/}
            {/*        minHeight: "0px",*/}
            {/*        fontSize: "24px",*/}
            {/*        fontWeight: "bold",*/}
            {/*        backgroundColor: "darkgray",*/}
            {/*        borderRadius: "4px 4px 0px 0px",*/}
            {/*        paddingLeft: "20px",*/}
            {/*        margin: "0"*/}
            {/*    }}>*/}
            {/*        Keresési Feltételek*/}
            {/*    </AccordionSummary>*/}
            {/*    <AccordionDetails className="filter-panel">*/}
            {/*        <Grid container columns={20} spacing={2} padding={"10px"}>*/}
            {/*            <Grid size={{lg: 4, md: 10, xs: 20}} sx={{padding: "0px"}}>*/}
            {/*                <TextField*/}
            {/*                    variant="outlined"*/}
            {/*                    margin="normal"*/}
            {/*                    fullWidth*/}
            {/*                    label="Termék Neve"*/}
            {/*                    name="name"*/}
            {/*                    autoComplete="off"*/}
            {/*                    onChange={onSearchParamsChange}*/}
            {/*                    sx={{margin: "0px"}}*/}
            {/*                    value={(searchParams && searchParams.name) || ""}*/}
            {/*                />*/}
            {/*            </Grid>*/}

            {/*            <Grid size={{lg: 4, md: 10, xs: 20}} sx={{padding: "0px"}}>*/}
            {/*                <TextField*/}
            {/*                    variant="outlined"*/}
            {/*                    margin="normal"*/}
            {/*                    fullWidth*/}
            {/*                    label="Gyártó"*/}
            {/*                    name="manufacturer"*/}
            {/*                    autoComplete="off"*/}
            {/*                    onChange={onSearchParamsChange}*/}
            {/*                    sx={{margin: "0px"}}*/}
            {/*                    value={(searchParams && searchParams.manufacturer) || ""}*/}
            {/*                />*/}
            {/*            </Grid>*/}

            {/*            <Grid size={{lg: 4, md: 10, xs: 20}} sx={{padding: "0px"}}>*/}
            {/*                <TextField*/}
            {/*                    variant="outlined"*/}
            {/*                    margin="normal"*/}
            {/*                    fullWidth*/}
            {/*                    label="Cikkszám"*/}
            {/*                    name="articleNumber"*/}
            {/*                    autoComplete="off"*/}
            {/*                    onChange={onSearchParamsChange}*/}
            {/*                    sx={{margin: "0px"}}*/}
            {/*                    value={(searchParams && searchParams.articleNumber) || ""}*/}
            {/*                />*/}
            {/*            </Grid>*/}

            {/*            <Grid size={{lg: 4, md: 10, xs: 20}} sx={{padding: "0px"}}>*/}
            {/*                <TextField*/}
            {/*                    variant="outlined"*/}
            {/*                    margin="normal"*/}
            {/*                    fullWidth*/}
            {/*                    label="EAN"*/}
            {/*                    name="ean"*/}
            {/*                    autoComplete="off"*/}
            {/*                    onChange={onSearchParamsChange}*/}
            {/*                    sx={{margin: "0px"}}*/}
            {/*                    value={(searchParams && searchParams.ean) || ""}*/}
            {/*                />*/}
            {/*            </Grid>*/}

            {/*            <Grid size={{lg: 4, md: 10, xs: 20}} sx={{padding: "0px", margin: "0px 0px 10px 0px"}}>*/}
            {/*                <Button onClick={clear} variant="contained" fullWidth*/}
            {/*                        style={{height: "56px", margin: "0px"}}>Szűrők Törlése</Button>*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*    </AccordionDetails>*/}
            {/*</Accordion>*/}
            <Paper sx={{width: '100%', overflow: 'hidden'}}>
                <TableContainer style={{maxHeight: "calc(100vh - 360px)"}}>
                    <Table stickyHeader aria-label="sticky table" sx={{tableLayout: 'fixed'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{fontWeight: 700, background: "lightgray", width: "50px"}}></TableCell>
                                {columns.map((column, index) => (
                                    <TableCell key={index} align={column.align} style={{fontWeight: 700, background: "lightgray"}}>
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.rows == null ? <TableRow sx={{textAlign: "center"}}><TableCell colSpan={17} sx={{
                                    padding: "200px",
                                    textAlign: "center"
                                }}><CircularProgress/></TableCell></TableRow> :
                                tableData.rows.map((row, index) => {
                                    return <Row row={row} navigate={navigate} key={index}/>
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[3, 10, 25, 50]}
                    component="div"
                    count={tableData.totalCount}
                    rowsPerPage={parseInt(tableData.rowsPerPage)}
                    page={tableData.page}
                    onPageChange={(event, newPage) => setTableData((prev) => ({...prev, page: newPage}))}
                    onRowsPerPageChange={(event) => {
                        setTableData((prev) => ({...prev, rowsPerPage: event.target.value, page: 0}))
                        localStorage.setItem(LOCAL_STORAGE_ITEM_NAME, event.target.value)
                    }}
                    labelRowsPerPage="Elemek oldalanként:"
                />
            </Paper>
        </>
    );
}

function Row(props) {

    const {row, navigate} = props;
    const [open, setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <TableRow sx={{'& > *': {borderBottom: 'unset !important'}}} onClick={() => setOpen(!open)}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUp/> : <KeyboardArrowDown/>}
                    </IconButton>
                </TableCell>
                {columns.map((column) => {
                    const value = column.fun ? column.fun(row[column.id], row, navigate) : row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align} component="th" scope="row"
                                   // onClick={() => navigate("/dashboard/storage/products/" + row.productId)}
                                   sx={{cursor: "pointer", padding: "10px"}}>
                            {value}
                        </TableCell>
                    );
                })}
            </TableRow>
            <TableRow sx={{height: open ? '' : '0px'}}>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={3}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{margin: 1}}>
                            <Table size="small" aria-label="purchases" sx={{tableLayout: 'fixed'}}>
                                <TableHead>
                                    <TableRow>
                                        {nestedColumns.map((column, index) => (
                                            <TableCell key={index} align={column.align} style={{fontWeight: 700, background: "whitesmoke", width: column.width}}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.reasons.map((reason, index) => (
                                        <TableRow key={reason.date} sx={{backgroundColor: reason.shortageDueToReservations > 0 ? '#fff4aa': ""}}>
                                        {nestedColumns.map((column) => {
                                                const value = column.fun ? column.fun(reason[column.id], reason, navigate) : reason[column.id];
                                                if(column.id === 'totalQuantityToOrder' && row.reasons[index -1]?.shortageDueToReservations > 0) return <></>
                                                return (
                                                    <TableCell key={column.id} align={column.align} component="th" scope="row"
                                                               rowSpan={column.id === 'totalQuantityToOrder' && reason.shortageDueToReservations > 0 ? 2 : 1}
                                                               sx={{padding: "0px", textAlign: column.align}}>
                                                        {value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>

                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
